import React from 'react';
import './CultureCards.css';

const CultureCards = ({ cultures }) => {
  // Use provided cultures or default examples
  const cultureList = cultures && cultures.length > 0 
    ? cultures.slice(0, 6) 
    : [
        {
          id: 1,
          name: 'Zulu',
          summary: 'Vibrant beadwork and ceremonial attire with intricate patterns',
          image: '🎨'
        },
        {
          id: 2,
          name: 'Xhosa',
          summary: 'Bold designs celebrating courage, tradition, and pride',
          image: '🌟'
        },
        {
          id: 3,
          name: 'Sotho',
          summary: 'Elegant woven baskets and blankets rich in heritage',
          image: '🧶'
        },
        {
          id: 4,
          name: 'Afrikaans',
          summary: 'Contemporary pieces rooted in heritage traditions',
          image: '👗'
        },
        {
          id: 5,
          name: 'Venda',
          summary: 'Sacred traditions in every stitch and embellishment',
          image: '✨'
        },
        {
          id: 6,
          name: 'Pan-African',
          summary: 'Celebrating African unity across borders and cultures',
          image: '🌍'
        }
      ];

  return (
    <section className="culture-cards section section--alt">
      <div className="container">
        <div className="culture-cards__header text-center">
          <h2>Shop by Culture</h2>
          <p className="culture-cards__subtitle">Explore authentic pieces from South African heritage traditions</p>
        </div>

        <div className="culture-cards__grid">
          {cultureList.map((culture) => (
            <a
              key={culture.id}
              href={`/products?culture=${culture.name.toLowerCase()}`}
              className="culture-card"
            >
              <div className="culture-card__image">
                {culture.image}
              </div>
              <div className="culture-card__content">
                <h3 className="culture-card__name">{culture.name}</h3>
                <p className="culture-card__summary">
                  {culture.summary}
                </p>
                <span className="culture-card__cta">
                  Explore Products →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CultureCards;
